import React, { Component } from 'react';
import './styles/About.css';

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  handleModalClose = (e) => {
    e.preventDefault();
    document.getElementById('about-modal').style.display = 'none';
  }

  render() {
    return (
      <div className='modal-wrapper' id='about-modal'>
        <div className='modal-content'>
          <span id='about-modal-closebtn' onClick={this.handleModalClose}>&#10006;</span>
          <h1 id='about-modal-header'> FollowCoronavirus.com </h1><br/>
          <h3>Developers: <a href="https://www.linkedin.com/in/faisalhossain75/" target="_blank">Faisal Hossain</a> and <a href="https://www.linkedin.com/in/william-darko/" target="_blank">William Darko</a> </h3><br/>
            <h4>With the current situations of the pandemic and its impacts on our economy, education, and lives, we found a need for the public to have a better
              quantitative understanding of the current state of COVID -19. Our web app project features an interactive globe with every infected country plotted 
              and a display of that country’s active case, death, and recovered counts. The website also features various charts, graphs, and critical 
              trends to provide an even better interpretation of the impact of COVID-19 - all in a digestible manner.
              </h4><br/>
            <h4>The data is sourced from <a href="https://github.com/CSSEGISandData/COVID-19" target="_blank">Johns Hopkins CSSE</a> and extracted using an API built by <a href="https://covid19api.com/" target="_blank">Kyle Redelinghuys</a> providing real-time and reliable updates. The website operates on local time and pulls new, updated 
              data every 10 minutes. Cases only include people who were tested and confirmed positive. Testing rules and availability vary by country. Some areas 
              may not have data because they haven’t published their data or haven’t done so recently.
              </h4><br/>
            <h4>Information is only any good if it reaches and helps the people it's intended for. Please help us spread this vital information so that our
              communities stay up to date on the pandemic right at home and effectively plan to contain it. We each have a responsibility to protect ourselves, 
              our loved ones, and our community. To help prevent the spread of coronavirus, take appropriate measures as listed on the <a href="https://www.cdc.gov/coronavirus/2019-ncov/index.html" target="_blank">CDC’s webpage</a> .
              </h4><br/>
            <h4>This page was developed quickly in order to maximize its use to the public. As such, all of the bugs with the mobile viewing experience aren't
              completely ironed out yet. Reopen the page if you encounter any issues, or view the page on a desktop or laptop for the best experience.
              </h4><br/>
            <h4>If you have questions, suggestions, or feedback, please fill out this <a href="https://forms.gle/72XmApAL9JZkzXi88" target="_blank">google forum</a>! You could also reach us at <a href="mailto:followcoronavirus@gmail.com?Subject=Follow%20Coronavirus%20Feedback" target="_top">followcoronavirus@gmail.com</a>. 
              We read every response in hopes to deliver a better experience for our users and develop an informative medium on the current climate of COVID-19.
              </h4><br/> 
            <h4>Also, as student developers, we humbly request that you please consider donating using the "By me a coffee" button below as it isn't free to keep the lights on for this website.
              </h4><br/>
        </div>
      </div>
    )
  }
}
